import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './WhyChooseLucods.css';

const WhyChooseLucods: React.FC = () => {
  const stats = [
    {
      number: '+15',
      label: 'Años de experiencia',
      description: 'Acompañando empresas en proyectos tecnológicos reales.'
    },
    {
      number: '+40',
      label: 'Proyectos implementados',
      description: 'En distintas industrias y contextos de negocio.'
    },
    {
      number: '+10',
      label: 'Industrias en las que trabajamos',
      description: 'Con soluciones adaptadas a procesos específicos.'
    },
  ];

  return (
    <section className="why-choose-section">
      <Container fluid="lg">
        <div className="section-intro mb-5 text-center">
          <h2 className="section-title">¿POR QUÉ ELEGIR LUCODS?</h2>
          <p className="section-subtitle fw-bold mb-3">
            Experiencia real + soluciones a medida = resultados sostenibles
          </p>
          <p className="section-text">
            Nos integramos a tu negocio como un socio tecnológico, entendiendo tus procesos y objetivos 
            para diseñar soluciones que impacten en la operación y el crecimiento.
          </p>
        </div>

        <Row className="g-5 justify-content-center">
          {stats.map((stat, index) => (
            <Col key={index} xs={12} sm={6} lg={4}>
              <div className="stat-card text-center">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
                <p className="stat-description">{stat.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default WhyChooseLucods;
